import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import BreakPoints from "../../../BreakPoints";
import DeleteUser from "../../../api/DeleteUser";
import SideBar from "../../../layout/SideBar";
import Footer from "../../../layout/Footer";
import { PROFILE } from "../../../api/Api";
import { UserContext } from "../../../context/UserContext";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { authAxios } from "../../../Axios/createAxios";
export default function UpdateProfile() {
  const { xSmall, small } = BreakPoints();
  const [changePassword, setChangePassword] = useState(false);
  const { userInfo } = useContext(UserContext);
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const queryClient = useQueryClient();
  const [userWantToChange, setUserWantToChange] = useState("");
  const [form, setForm] = useState({});
  const { token } = useParams();
  useEffect(() => {
    if (token) {
      authAxios
        .post(`/verify-new-email/${token}`)
        .then((res) => console.log(res))
        .catch((e) => console.log(e));
    }
  }, [token]);

  const updateData = async () => {
    try {
      const res = await authAxios.patch(
        `/${PROFILE}`,
        {
          [userWantToChange]: form[userWantToChange],
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      console.log(res);
      return res;
    } catch (e) {
      console.log(e);
      throw new Error(e);
    }
  };

  const mutation = useMutation({
    mutationFn: updateData,
    onSuccess: () => {
      queryClient.invalidateQueries("profile");
      console.log(mutation.data);
    },
    onError: () => {
      console.log(mutation.error);
    },
  });
  console.log(mutation.data);
  const handleSubmit = (e) => {
    e.preventDefault();
    mutation.mutate();
  };

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setForm({
      [name]: value,
    });
  };

  return (
    <>
      <div className="settings-page">
        {!small && !xSmall && <SideBar />}

        <section className="settings-list relative">
          <span className="h4 block">Account settings</span>
          <ul>
            <li onClick={() => setUserWantToChange("email")}>{userInfo.email}</li>
            <li onClick={() => setUserWantToChange("name")}>{userInfo.name}</li>
            <li onClick={() => setChangePassword(true)}>Change password</li>
            <li className="d-contents">
              <DeleteUser id={userInfo.id} currentPassword={currentPassword} />
            </li>
          </ul>
          {userWantToChange && (
            <form
              onSubmit={handleSubmit}
              className="absolute prime-bg-c pl-20 pr-20"
              style={{ width: "100%", height: "100%", left: "0", top: "0" }}>
              <span
                className="h6 block"
                onClick={() => {
                  setUserWantToChange(null);
                  setForm("");
                }}>
                <i className="fa-solid fa-arrow-left mr-10"></i>Change {userWantToChange}
              </span>
              <input
                className={`p-10 radius-6`}
                name={userWantToChange}
                placeholder={`Enter New ${userWantToChange}`}
                onChange={handleOnChange}
                defaultValue={form[userWantToChange]}
                type={userWantToChange === "password" ? "password" : "text"}
              />
              {userWantToChange === "password" && (
                <input
                  style={{ marginTop: "10px" }}
                  className={`p-10 radius-6`}
                  name="password_confirmation"
                  placeholder="Confirm new password"
                  onChange={(e) => setPasswordConfirmation(e.target.value)}
                  value={passwordConfirmation}
                  type="password"
                />
              )}

              <button className={`p-10 mixed-bg-c radius-4 `}>next</button>
            </form>
          )}
          {changePassword && (
            <div>
              <span>wanna change Your Password</span>
              <button onClick={() => setChangePassword(false)}>no</button>
              <button>yes</button>
            </div>
          )}
        </section>
      </div>
      {(small || xSmall) && <Footer />}
    </>
  );
}
